import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
//Organizations_Authentications
import Organizationssignup from './components/organizations/SignupOrganizations/signup';
import Organizationssigin from './components/organizations/LoginOrganizations/Login';
import OrganizationsForgotpassword from './components/organizations/ForgotPasswordOrganizations/ForgotPassword';
import OrganizationsProject from './components/organizations/organizationsProjects/organizationsProject';
import PostProject from './components/organizations/organizationsProjects/postProject';
import ProjectSubmission from './components/organizations/organizationsProjects/projectSubmission';
import PostprojectsUploads from './components/organizations/organizationsProjects/postprojectsuploads';
import Compainesdashboard from './components/organizations/organizationsDashboard/organizations_dashboard';
import OrganizationActiveprojects from "./components/organizations/organizationsDashboard/Active";
import OrganizationPendingprojects from "./components/organizations/organizationsDashboard/pendingProjects";
import OrganizationCompletedprojects from "./components/organizations/organizationsDashboard/Completed";
import HireTachTalent from './components/organizations/hireTachTalent/hiretach';
import HireTachTalents from './components/organizations/hireTachTalent/hireTachs';
import HireTalentDetails from './components/organizations/hireTachTalent/hiretachtalentdata';
import Hireingappliedusers from "./components/organizations/hireTachTalent/appliedusers";
import OrganizationHireTechdata from "./components/organizations/hireTachTalent/organizationHiringdata";
import OrganizationHireTechupdate from "./components/organizations/hireTachTalent/EditHireTechPost";
import Organizationprofile from "./components/organizations/organizationsDashboard/organizationProfile";
import IdeavizeOrganization from "./components/organizations/ideavize";
//Learners_Authentications
import Signup from './components/Learners/Learnersdashboard/Signup/signup';
import Sigin from './components/Learners/Learnersdashboard/Login/login';
import ForgotPassword from './components/Learners/Learnersdashboard/ForgotPassword/forgotPassword';
//Learners_dashboard
import Dashboardhomepage from './components/Learners/Learnersdashboard/LearnersDashboard/dashboardhomepage';
// Learning_Path_Iot
import Topbar from './components/Learners/Learnersdashboard/iotLearningPath/topbar';
import Userprofile from './components/Learners/Learnersdashboard/Learners_data/userprofile/userprofile';
import Dashboard from './components/Learners/Learnersdashboard/iotLearningPath/dashboard';
import SidebarComponent from './components/Learners/Learnersdashboard/iotLearningPath/Sidebar';
import Learningpath from './components/Learners/Learnersdashboard/iotLearningPath/LearningPaths/Learning-Paths';
import Iotdeveloper from "./components/Learners/Learnersdashboard/iotLearningPath/LearningPaths/iotdeveloper";
import Industrialiot from "./components/Learners/Learnersdashboard/iotLearningPath/LearningPaths/industrialiot";
import Iotsecurity from "./components/Learners/Learnersdashboard/iotLearningPath/Courses/iotsecurityspecialist";
import Iotdatascientist from "./components/Learners/Learnersdashboard/iotLearningPath/LearningPaths/iotdataScientist";
import Iothardware from "./components/Learners/Learnersdashboard/iotLearningPath/Courses/iothardwareengineer";
import Started from './components/Learners/Learnersdashboard/learningpath/Customizedpath';
import Courses from './components/Learners/Learnersdashboard/iotLearningPath/addCoursesList/courses/courses';
import Projects from './components/Learners/Learnersdashboard/iotLearningPath/addCoursesList/projects/projects';
import Applyforworks from "./components/Learners/Learnersdashboard/Learners_data/Applynow/internships";
import LiveSessions from './components/Learners/Learnersdashboard/Live-Sessions/Live-Sessions';
// import Work from './components/Learners/Learnersdashboard/iotLearningPath/applyforWork';
import Work from './components/Learners/Learnersdashboard/iotLearningPath/applyworks';
import BootCamps from './components/Learners/Learnersdashboard/iotLearningPath/LearningPaths/bootCamps';
// Learning_Path_for_Data_science
import DataScienceSidebarComponent from "./components/Learners/Learnersdashboard/datascienceLearningPath/Sidebar";
import DataScienceDashboard from './components/Learners/Learnersdashboard/datascienceLearningPath/dashboard';
import DataScienceTopbar from './components/Learners/Learnersdashboard/datascienceLearningPath/topbar';
import DatascienceLearningPaths from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Learning-Paths";
import BusinessIntelligence from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Business-Intelligence";
import MachineLearningAI from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Machine-Learning";
import DataEngineering from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Data-Engineering";
import GenerativeAI from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Generative-AI";
import CertifiedDataScientist from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Certified-Data-Scientist";
import DataScienceArtificialIntelligence from "./components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/Data-Science-Artificial-Intelligence";
import DataScienceCourses from './components/Learners/Learnersdashboard/datascienceLearningPath/addCoursesList/courses/courses';
import DataScienceProjects from './components/Learners/Learnersdashboard/datascienceLearningPath/addCoursesList/projects/projects';
import DataScienceWork from './components/Learners/Learnersdashboard/datascienceLearningPath/applyforWork';
import DatascienceBootCamps from './components/Learners/Learnersdashboard/datascienceLearningPath/LearningPaths/bootCamps';
import DatascienceapplyWorks from './components/Learners/Learnersdashboard/datascienceLearningPath/applyforWork';
import DataScienceLiveSessions from './components/Learners/Learnersdashboard/Live-Sessions/datascienceMentors';
//Learning_Path_for_Embedded_Systems
import EmbeddedSystemsSidebarComponent from "./components/Learners/Learnersdashboard/embeddedSystemsLearningPath/Sidebar";
import EmbeddedSystemsDashboard from './components/Learners/Learnersdashboard/embeddedSystemsLearningPath/dashboard';
import EmbeddedSystemsTopbar from './components/Learners/Learnersdashboard/embeddedSystemsLearningPath/topbar';
import EmbeddedSystemsLearningPaths from "./components/Learners/Learnersdashboard/embeddedSystemsLearningPath/LearningPaths/Learning-Paths";
import Embeddedsystem from "./components/Learners/Learnersdashboard/embeddedSystemsLearningPath/LearningPaths/embeddedSystems";
import Iotembeddedsystems from "./components/Learners/Learnersdashboard/embeddedSystemsLearningPath/LearningPaths/iotEmbeddedSystems";
import Embeddedlinux from "./components/Learners/Learnersdashboard/embeddedSystemsLearningPath/LearningPaths/embeddedLinux";
import Automotiveapplications from "./components/Learners/Learnersdashboard/embeddedSystemsLearningPath/LearningPaths/automotiveApplications";
import EmbeddedsystemsCourses from './components/Learners/Learnersdashboard/embeddedSystemsLearningPath/addCoursesList/courses/courses';
import EmbeddedsystemsProjects from './components/Learners/Learnersdashboard/embeddedSystemsLearningPath/addCoursesList/projects/projects';
import EmbeddedsystemsWork from './components/Learners/Learnersdashboard/embeddedSystemsLearningPath/applyforWork';
import EmbeddedsystemsLiveSessions from './components/Learners/Learnersdashboard/Live-Sessions/embeddedsystemsMentors';

import Capstoneaimagic from './components/Learners/Learnersdashboard/capstoneaimagic/capstoneaimagic';
import IdeavizeSSOPage from './components/Learners/Learnersdashboard/ideavize';
import ProtectedRoutes from './helper/organizationstoken';
import ProtectedRoute from './helper/learnersToken';
import PageNotFound from './helper/PageNotFound';
import * as amplitude from '@amplitude/analytics-browser';
// Custom Amplitude config
// const config = {};

// export const initAmplitude = () => {
//   amplitude.init(AMPLITUDE_PROJECT_ID, undefined, config);
  amplitude.init('7d242daccb34990cf675f19b2bacaf9a', {"autocapture":true});

function App() {

    return (
        <>
            <CssBaseline />
            <div className="app">
                <Routes>
                    {/* Companies routes */}
                    <Route path="*" element={<PageNotFound />} />
                    <Route path="/organizations/signup" element={<Organizationssignup />} />
                    <Route path="/organizations/signin" element={<Organizationssigin />} />
                    <Route path="/organizations/forgot-password" element={<OrganizationsForgotpassword />} />
                    <Route element={<ProtectedRoutes />}>
                    <Route path="/organizations/new-post-project" element={<OrganizationsProject />} />
                    <Route path="/organizations/post-project" element={<PostProject />} />
                    <Route path="/organizations/project-submission" element={<ProjectSubmission />} />
                    <Route path="/organizations/project-confirmation" element={<PostprojectsUploads />} />
                    <Route path="/organizations/dashboard/*" element={<CompainesdashboardLayout />} />
                    <Route path="/organizations/hire-tech-talent" element={<HireTachTalent />} />
                    <Route path="/organizations/hire-tech-talents" element={<HireTachTalents />} />
                    <Route path="/organizations/hire-tech-talent-submit" element={<HireTalentDetails />} />
                    </Route>
                    {/* Learners Authentication routes */}
                    <Route path="/learners/signup" element={<Signup />} />
                    <Route path="/learners/signin" element={<Sigin />} />
                    <Route path="/learners/forgot-password" element={<ForgotPassword />} />
                     {/* Learners  Dashboard routes */}
                     <Route path="/learners/dashboardpage" element={<Dashboardhomepage />} />
                     <Route element={<ProtectedRoute />}>
                     <Route path="/learners/dashboard/*" element={<DashboardLayout />} />
                     <Route path="/learners/data-science-dashboard/*" element={<DataScienceDashboardLayout />} />
                     <Route path="/learners/embedded-systems-dashboard/*" element={<EmbeddedSystemsDashboardLayout />} />
                     </Route>
                </Routes>
            </div>
        </>
    );
}

function CompainesdashboardLayout() {
    return (
        <>
            <Compainesdashboard />
            <main className="content">
                <Routes>
                    <Route element={<ProtectedRoutes />}>
                    <Route path="active-project" element={<OrganizationActiveprojects />} />
                    <Route path="pending-project" element={<OrganizationPendingprojects />} />
                    <Route path="completed-project" element={<OrganizationCompletedprojects />} />
                    <Route path="hire-tech-data" element={<OrganizationHireTechdata />} />
                    <Route path="hire-tech-data-update" element={<OrganizationHireTechupdate />} />
                    <Route path="hire-tech-hired-users" element={<Hireingappliedusers />} />
                    <Route path="profile" element={<Organizationprofile />} />
                    <Route path="ideavize-ai" element={<IdeavizeOrganization />} />
                    </Route>
                </Routes>
            </main>
        </>
    );
}

function DashboardLayout() {
    return (
        <>
            <SidebarComponent />
            <main className="content">
                <Topbar />
                <Routes>
                    <Route element={<ProtectedRoute />}>
                    <Route index element={<Dashboard />} />
                    <Route path="internetofthings" element={<Learningpath />} />
                    <Route path="internetofthings/iot-developer-engineer" element={<Iotdeveloper />} />
                    <Route path="internetofthings/iot-data-scientist" element={<Iotdatascientist />} />
                    <Route path="internetofthings/industrial-iot-industry" element={<Industrialiot />} />
                    <Route path="internetofthings/iot-security-specialist" element={<Iotsecurity />} />
                    <Route path="internetofthings/iot-hardware-engineer" element={<Iothardware />} />
                    <Route path="internetofthings/iot-boot-camps" element={<BootCamps />} />
                    <Route path="internetofthings/started" element={<Started />} />
                    <Route path="courses" element={<Courses />} />
                    <Route path="projects" element={<Projects />} />
                    <Route path="capstoneaimagic" element={<Capstoneaimagic />} />
                    <Route path="mentorconnect" element={<LiveSessions />} />
                    <Route path="userprofile" element={<Userprofile />} />
                    <Route path="work" element={<Work />} />
                    <Route path="apply" element={<Applyforworks/>} />
                    <Route path="ideavize-ai" element={<IdeavizeSSOPage />} />
                    </Route>
                </Routes>
            </main>
        </>
    );
}

function DataScienceDashboardLayout() {
    return (
        <>
            <DataScienceSidebarComponent />
            <main className="content">
                <DataScienceTopbar />
                <Routes>
                    <Route element={<ProtectedRoute />}>
                    <Route index element={<DataScienceDashboard />} />
                    {/*  Learning Paths for Data science */}
                    <Route path="data-science-learningpath" element={<DatascienceLearningPaths />} />
                    <Route path="data-science-learningpath/business-intelligence" element={<BusinessIntelligence />} />
                    <Route path="data-science-learningpath/machine-learning-ai" element={<MachineLearningAI />} />
                    <Route path="data-science-learningpath/data-engineering" element={<DataEngineering />} />
                    <Route path="data-science-learningpath/generative-ai" element={<GenerativeAI />} />
                    <Route path="data-science-learningpath/certified-data-scientist" element={<CertifiedDataScientist />} />
                    <Route path="data-science-learningpath/data-science-artificial-intelligence" element={<DataScienceArtificialIntelligence />} />
                    <Route path="data-science-learningpath/data-science-boot-camps" element={<DatascienceBootCamps />} />
                    <Route path="courses" element={<DataScienceCourses />} />
                    <Route path="projects" element={<DataScienceProjects />} />
                    <Route path="capstoneaimagic" element={<Capstoneaimagic />} />
                    <Route path="mentorconnect" element={<DataScienceLiveSessions />} />
                    <Route path="userprofile" element={<Userprofile />} />
                    <Route path="work" element={<DatascienceapplyWorks />} />
                    <Route path="apply" element={<DataScienceWork/>} />
                    <Route path="ideavize-ai" element={<IdeavizeSSOPage />} />
                    </Route>
                </Routes>
            </main>
        </>
    );
}

function EmbeddedSystemsDashboardLayout() {
    return (
        <>
            <EmbeddedSystemsSidebarComponent />
            <main className="content">
                <EmbeddedSystemsTopbar />
                <Routes>
                    <Route element={<ProtectedRoute />}>
                    <Route index element={<EmbeddedSystemsDashboard />} />
                    {/*  Learning Paths for Data science */}
                    <Route path="embedded-systems-learningpath" element={<EmbeddedSystemsLearningPaths />} />
                    <Route path="embedded-systems-learningpath/embedded-systems" element={<Embeddedsystem />} />
                    <Route path="embedded-systems-learningpath/iot-embedded-systems" element={<Iotembeddedsystems />} />
                    <Route path="embedded-systems-learningpath/embedded-linux" element={<Embeddedlinux />} />
                    <Route path="embedded-systems-learningpath/automotive-applications" element={<Automotiveapplications />} />
                    <Route path="courses" element={<EmbeddedsystemsCourses />} />
                    <Route path="projects" element={<EmbeddedsystemsProjects />} />
                    <Route path="capstoneaimagic" element={<Capstoneaimagic />} />
                    <Route path="mentorconnect" element={<EmbeddedsystemsLiveSessions />} />
                    <Route path="userprofile" element={<Userprofile />} />
                    <Route path="work" element={<EmbeddedsystemsWork />} />
                    <Route path="ideavize-ai" element={<IdeavizeSSOPage />} />
                    </Route>
                </Routes>
            </main>
        </>
    );
}

export default App;
